import './style.modules.scss'

import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React from 'react'

import { Link } from '../../types/Link.type'
import { RelatedInfoLink } from './RelatedInfoLink'

export type RelatedInfoProps = {
  className?: string
  superHeadline?: string
  links?: Link[]
  analyticsName?: string
  testId?: string
}

export const RelatedInfo = (props: RelatedInfoProps) => {
  const { className, superHeadline, links, analyticsName, testId } = props

  const atb = new AnalyticsTagBuilder()
    .setDefaultName('RelatedInfo')
    .setAnalyticsName('relatedInfo-content-links-clicks')

  const relatedInfoLinks = links ? (Array.isArray(links) ? links : [links]) : []

  const visibleLinks = relatedInfoLinks.filter(link => {
    return link.url && !link.url.includes('/zzz__hidden__/')
  })

  if (visibleLinks.length === 0) {
    return null
  }

  return (
    <div
      className={`RelatedInfo u-bgColorStone u-sm-marginLeft0 u-md-marginLeft0 ${className}`}
      data-testid={testId ? `${testId}` : undefined}
    >
      <div
        className="RelatedInfo-content u-sm-paddingHoriz20 u-sm-paddingVert20"
        {...atb.dataAnalyticAttribute(analyticsName)}
      >
        <h1
          className="u-textPrimary u-textColorNeutral u-textBold u-textSizeMsrp2 u-paddingBottom20"
          data-testid={testId ? `${testId}-heading` : undefined}
        >
          {superHeadline?.trim() || 'Related Information'}
        </h1>
        <ul>
          {visibleLinks.map((link, key) => {
            return (
              <RelatedInfoLink
                key={key}
                link={link}
                testId={testId ? `${testId}-link` : undefined}
              />
            )
          })}
        </ul>
      </div>
    </div>
  )
}
